import type { FaireProductEntity } from "../../entity_types/product";

export const p_g4wyn6knsq: FaireProductEntity = {
  token: "p_g4wyn6knsq",
  type: "product",
  name: '"BEAR WITH SALMON" GRAPHIC LONG SLEEVE CREW NECK SWEATER',
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/72d42ac4e17122af006cdc9b990886bb3977ffc94402b8af24f9edfb5c04379a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5687e7f55ebb085ff825d05151e359af4a1d0a98e0241b5d2ed4011e12107fcd.jpeg",
    "https://cdn.faire.com/fastly/cb263308840c151e64760866e597e11a50101a2991712eabb1df16e2a741fcc0.jpeg",
    "https://cdn.faire.com/fastly/9e778f20dcefe8a76cfbb048c892d2dd6af160f071ebf399f36a842a07d5e663.jpeg",
    "https://cdn.faire.com/fastly/a996f86691d1a317217d01dc5b670b5c332db99ab384a41ce1d5dd4ff750a02c.jpeg",
    "https://cdn.faire.com/fastly/47d3a0de65944d48d2e77dccbcab43fc1c82fb36ed6695042d41d29d40516850.jpeg",
  ],
  priceDollars: 192,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'10"\nBUST: 33B\nWAIST: 23.5"\nHIPS: 35"',
  tags: [],
  msrpDollars: 384,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:11.805Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
